import Keycloak from "keycloak-js"

/**
 * The Keycloak realm every environment of the app authenticates against.
 */
export const REALM = "Docoon"

/**
 * The app's single Keycloak client.
 */
let instance: Keycloak | null = null

/**
 * Builds the Keycloak client and registers it as the app's instance.
 *
 * @param {string} url - Base URL of the Keycloak server, read from settings.json.
 * @returns {Keycloak} The client.
 * @throws {Error} When `url` is missing.
 */
export function createKeycloak(url: string): Keycloak {
    if (!url) {
        throw new Error("KEYCLOAK_URL is not set in settings.json")
    }

    instance = new Keycloak({
        url,
        realm: REALM,
        clientId: "docoon"
    })

    return instance
}

/**
 * The app's Keycloak client instance, or null before `createKeycloak` has run.
 *
 * @returns {Keycloak | null} The client, or null.
 */
export function getKeycloak(): Keycloak | null {
    return instance
}
